const paths = {
  HOME: "/",

  CASH_COLLECTION: "/cash-collection",
  MANUAL_SWAP: "/manual-swap",
  BATTERY_MOVEMENT: "/battery-movement",

  EMI_CALCULATOR: "/emi-calculator",
  DRIVER_LEAD_CREATION_V1: "/driver-lead-creation-v1",
  DRIVER_LEAD_CREATION: "/driver-lead-creation",
  LEAD_DOCUMENTATION: "/driver-lead-documentation/:leadId",
  DRIVER_ONBOARDING: "/driver-onboarding",

  DRIVER_PRE_ONBARDING: `/driver-onboarding?tab=pre-onboarding`,

  PRE_ONBOARDING_UPDATE: "/pre-onboarding-update/:prn",

  LOGIN: "/login",
};

export default paths;
